import VideoBanner from "@/components/ui/video-banner";
import React from "react";
import { m } from "framer-motion";
import { fadeInUp } from "@/utils/motion/fade-in-up";
export default function Banner() {
  return (
    <div className="relative w-full h-full">
      <VideoBanner
        data={{
          video:"/videos/career-head.mp4",
            // "https://video.wixstatic.com/video/a511f3_2510afc013cc454b893b753fd63ac740/1080p/mp4/file.mp4",
        }}
      />
      <m.div
        initial={"from"}
        whileInView={"to"}
        variants={fadeInUp(1, 1.5)}
        viewport={{ once: true }}
        className="absolute top-0 left-0 w-full h-screen flex flex-col items-center justify-center md:gap-4 gap-2"
      >
        <p className="text-beige/80 text-sm text-center">28°41’ N, 77°08’E</p>
        <h1 className="font-havletica font-light uppercase text-center  text-white">
         Explore design careers at Chalk Studio shaped by innovation, collaboration, and passion.
        </h1>
        <p className="text-beige/80 text-sm text-center">Gurugram</p>
      </m.div>
    </div>
  );
}
